import React, { Component } from "react";
import { connect } from "react-redux";
import PopUpForm from "../../Generic/PopUpDialog/PopUpForm";
import { addressFields } from "../fields";
import { API } from "aws-amplify";
import { setRefresh } from "../../../actions/algoliaActions";
import { setLoaderState, setAlgoliaLoaderState } from "../../../actions/loaderActions";
import { updateAddressDetails, selectAddress } from "../../../actions/staffActions";

class AddAddress extends Component {
  staffId = this.props.match.params.staffId;

  async APIMethod(formData) {
    this.props.dispatch(setAlgoliaLoaderState(true));
    try {
      this.props.dispatch(setLoaderState(true));

      const response = await API.post("telishadeAPI", "/staff/" + this.staffId + "/address", {
        body: {
          details: {
            name: formData.name ? formData.name : "Untitled Address",
            addressType: formData.addressType,
            address: {
              streetNumber: formData.streetNumber,
              streetName: formData.streetName,
              city: formData.city,
              postcode: formData.postcode,
              state: formData.state,
              country: formData.country
            }
          }
        }
      });

      await this.props.dispatch(updateAddressDetails(response.details));
      await this.props.dispatch(selectAddress(response.id));
      this.props.dispatch(setRefresh(true));
      this.props.dispatch(setAlgoliaLoaderState(false));
      this.props.history.push(`/staff/${response.staffId}/addresses/${response.id}`);
    } catch (error) {
      throw error;
    } finally {
      setTimeout(() => {
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setRefresh(true));
        this.props.dispatch(setRefresh(false));
        this.props.dispatch(setLoaderState(false));
        this.props.dispatch(setAlgoliaLoaderState(false));
      }, 0);
    }
  }

  render() {
    const fields = [...addressFields];

    return (
      <PopUpForm
        fields={fields}
        header="Add New Address"
        button="ACCEPT"
        buttoncolour="green"
        button2="CANCEL"
        button2colour="red"
        buttonClickHandler={undefined}
        button2ClickHandler={undefined}
        apiMethod={details => this.APIMethod(details)}
      />
    );
  }
}
const mapStateToProps = state => {
  return state.staff.address;
};

export default connect(mapStateToProps)(AddAddress);
